export const routePaths = {
    root: "/",
    login: "/login",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    dashboard: "/dashboard",
    dashboardWorkspace: "/dashboard/workspace",
    adminAccess: "/settings/access",
    messages: "/messages",
    changePassword: "/settings/password",
    clients: "/clients",
    client360: "/clients/360",
    clientHistory: "/clients/history",
    orders: "/orders",
    orderItems: "/orders/items",
    loyalty: "/loyalty",
    b2b: "/b2b",
    wholesalePromotions: "/b2b/promotions",
    wholesaleSuppliers: "/b2b/suppliers",
    campaigns: "/campaigns",
    bi: "/bi",
    retailCockpit: "/retail/cockpit",
    retailFrequency: "/retail/frequency",
    retailPercentTargets: "/retail/percent-targets",
    retailDefectsSliven: "/retail/defects-sliven",
    onlineCockpit: "/online/cockpit",
    expenses: "/expenses",
    expensesTransport: "/expenses/transport",
    expensesMarketing: "/expenses/marketing",
    expensesSalaries: "/expenses/salaries",
    grafica: "/grafica/grafica",
    grafica2: "/grafica/grafica2",
} as const;

export const workspaceNavItems = [
    {
        path: routePaths.adminAccess,
        label: "Потребители и роли",
        description: "Администрация на достъпа, ролите и правата.",
    },
    {
        path: routePaths.dashboard,
        label: "Контролен център",
        description: "Омниканален преглед на интеграции, клиенти, поръчки и рискове.",
    },
    {
        path: routePaths.clients,
        label: "Клиенти",
        description: "Обединени клиентските профили, канални връзки, Канал и качество на данните.",
    },
    {
        path: routePaths.orders,
        label: "Поръчки",
        description: "Единен изглед на поръчките от магазин, онлайн магазин и търговия на едро.",
    },
    {
        path: routePaths.loyalty,
        label: "Червена карта",
        description: "Издаване, статус, нива на отстъпка, партиди номера и POS проверка.",
    },
    {
        path: routePaths.b2b,
        label: "Търговия на едро",
        description: "Фирмени профили, ценови листи, кредитни условия и поръчки на едро.",
    },
    {
        path: routePaths.campaigns,
        label: "Кампании",
        description: "Създаване, планиране и изпращане на маркетингови кампании.",
    },
    {
        path: routePaths.bi,
        label: "Анализи",
        description: "Продажби - финанси, екип, маркетинг и прогнози.",
    },
] as const;

export function getActiveWorkspaceItem(pathname: string) {
    if (pathname === routePaths.changePassword) {
        return {
            path: routePaths.changePassword,
            label: "Сигурност",
            description: "Смяна на парола и контрол на достъпа.",
        };
    }

    if (
        pathname === routePaths.grafica ||
        pathname.startsWith(`${routePaths.grafica}/`) ||
        pathname === routePaths.grafica2 ||
        pathname.startsWith(`${routePaths.grafica2}/`)
    ) {
        return (
            workspaceNavItems.find((item) => item.path === routePaths.bi) ??
            workspaceNavItems[0]
        );
    }

    return (
        workspaceNavItems.find(
            (item) => pathname === item.path || pathname.startsWith(`${item.path}/`)
        ) ?? workspaceNavItems[0]
    );
}
